export const childFormBirthdayField = "child.birthDate";

export const childFormTestId = "components/fragments/argyle/child-form/form";
export const childFormTitleTestId = "components/fragments/argyle/child-form/title";
export const childFormDescriptionTestId = "components/fragments/argyle/child-form/description";
